import React, { useEffect } from 'react';
import '../LegalPages.css';

function Privacidad() {
  useEffect(() => {
    // Set page title
    document.title = 'Política de Privacidad | Agencia La Botica';
    
    // Add noindex meta tag
    let metaRobots = document.querySelector('meta[name="robots"]');
    if (!metaRobots) {
      metaRobots = document.createElement('meta');
      metaRobots.name = 'robots';
      document.head.appendChild(metaRobots);
    }
    metaRobots.content = 'noindex, nofollow';

    return () => {
      // Cleanup: remove noindex when leaving the page
      if (metaRobots) {
        metaRobots.content = 'index, follow';
      }
    };
  }, []);

  return (
    <div className="legal-page">
      <div className="legal-container">
        <header className="legal-header">
          <a href="/" className="legal-logo">
            <img src="/logo-labotica.svg" alt="Agencia La Botica" />
          </a>
        </header>

        <main className="legal-content">
          <h1>Política de Privacidad</h1>
          <p className="legal-updated">Última actualización: Febrero 2026</p>

          <section>
            <h2>1. Información General</h2>
            <p>
              En <strong>Agencia de Publicidad La Botica Limitada</strong> ("La Botica", "nosotros"), 
              con domicilio en Santiago de Chile, nos comprometemos a proteger la privacidad de 
              nuestros usuarios. Esta Política de Privacidad describe cómo recopilamos, usamos, 
              almacenamos y protegemos tu información personal cuando visitas nuestro sitio web 
              agencialabotica.cl o interactúas con nuestros servicios.
            </p>
          </section>

          <section>
            <h2>2. Datos que Recopilamos</h2>
            <p>Podemos recopilar los siguientes tipos de información:</p>
            <ul>
              <li><strong>Datos de identificación:</strong> nombre completo, correo electrónico, número de teléfono, empresa u organización.</li>
              <li><strong>Datos de uso:</strong> información sobre cómo interactúas con nuestro sitio web, incluyendo páginas visitadas, tiempo de permanencia y acciones realizadas.</li>
              <li><strong>Datos técnicos:</strong> dirección IP, tipo de navegador, sistema operativo, dispositivo utilizado.</li>
              <li><strong>Datos de comunicación:</strong> consultas, solicitudes o mensajes que nos envíes a través del chatbot o formularios de contacto.</li>
            </ul>
          </section>

          <section>
            <h2>3. Cómo Utilizamos tus Datos</h2>
            <p>Utilizamos la información recopilada para:</p>
            <ul>
              <li>Responder a tus consultas y solicitudes de información.</li>
              <li>Proporcionarte cotizaciones y propuestas de servicios.</li>
              <li>Mejorar nuestro sitio web y la experiencia del usuario.</li>
              <li>Enviar comunicaciones relacionadas con nuestros servicios (solo si has dado tu consentimiento).</li>
              <li>Cumplir con obligaciones legales aplicables.</li>
            </ul>
          </section>

          <section>
            <h2>4. Compartición de Datos con Terceros</h2>
            <p>
              Podemos compartir información con plataformas y servicios de terceros para mejorar 
              nuestra presencia digital y analizar el rendimiento de nuestras campañas. Estos terceros incluyen:
            </p>
            <ul>
              <li><strong>Meta (Facebook e Instagram):</strong> para publicidad y análisis de redes sociales.</li>
              <li><strong>Google:</strong> para análisis web (Google Analytics) y publicidad (Google Ads).</li>
              <li><strong>LinkedIn:</strong> para publicidad y análisis en redes profesionales.</li>
              <li><strong>Otras plataformas de redes sociales y análisis</strong> que utilicemos en el futuro.</li>
            </ul>
            <p>
              Estos terceros tienen sus propias políticas de privacidad y te recomendamos revisarlas. 
              No vendemos ni alquilamos tu información personal a terceros.
            </p>
          </section>

          <section>
            <h2>5. Cookies y Tecnologías Similares</h2>
            <p>
              Nuestro sitio web puede utilizar cookies y tecnologías similares para mejorar tu 
              experiencia de navegación, recordar tus preferencias y analizar el tráfico del sitio. 
              Puedes configurar tu navegador para rechazar cookies, aunque esto puede afectar 
              algunas funcionalidades del sitio.
            </p>
          </section>

          <section>
            <h2>6. Tus Derechos</h2>
            <p>De acuerdo con la legislación chilena aplicable, tienes derecho a:</p>
            <ul>
              <li><strong>Acceso:</strong> solicitar información sobre los datos personales que tenemos sobre ti.</li>
              <li><strong>Rectificación:</strong> corregir datos inexactos o incompletos.</li>
              <li><strong>Eliminación:</strong> solicitar la eliminación de tus datos personales.</li>
              <li><strong>Oposición:</strong> oponerte al tratamiento de tus datos en determinadas circunstancias.</li>
            </ul>
            <p>
              Para ejercer cualquiera de estos derechos, puedes contactarnos a través de 
              <a href="mailto:pablo@agencialabotica.cl"> pablo@agencialabotica.cl</a> o visitar 
              nuestra página de <a href="/eliminacion-datos">Solicitud de Eliminación de Datos</a>.
            </p>
          </section>

          <section>
            <h2>7. Seguridad de los Datos</h2>
            <p>
              Implementamos medidas de seguridad técnicas y organizativas para proteger tu 
              información personal contra acceso no autorizado, pérdida o alteración. Sin embargo, 
              ninguna transmisión de datos por Internet es completamente segura, por lo que no 
              podemos garantizar la seguridad absoluta de la información transmitida.
            </p>
          </section>

          <section>
            <h2>8. Legislación Aplicable</h2>
            <p>
              Esta Política de Privacidad se rige por la legislación chilena, incluyendo la 
              Ley N° 19.628 sobre Protección de la Vida Privada y sus modificaciones. 
              Cualquier controversia será sometida a los tribunales competentes de Santiago de Chile.
            </p>
          </section>

          <section>
            <h2>9. Modificaciones</h2>
            <p>
              Nos reservamos el derecho de modificar esta Política de Privacidad en cualquier momento. 
              Los cambios serán publicados en esta página con la fecha de actualización correspondiente.
            </p>
          </section>

          <section>
            <h2>10. Contacto</h2>
            <p>
              Si tienes preguntas sobre esta Política de Privacidad o sobre el tratamiento de tus 
              datos personales, puedes contactarnos en:
            </p>
            <p>
              <strong>Agencia de Publicidad La Botica Limitada</strong><br />
              Santiago de Chile<br />
              Email: <a href="mailto:pablo@agencialabotica.cl">pablo@agencialabotica.cl</a>
            </p>
          </section>
        </main>

        <footer className="legal-footer">
          <p>© 2026 Agencia La Botica — Santiago, Chile</p>
        </footer>
      </div>
    </div>
  );
}

export default Privacidad;
